import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { RadioState } from '@app/core/states/radio.state';
import { BacGroup } from '@app/library/models/bac.model';
import { SearchService } from '@app/library/services/search.service';
import { BacsState } from '@app/library/states/bacs.state';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Select, Store } from '@ngxs/store';
import { SchedulerCoreState, SchedulerTrack } from '@radioking/scheduler-core';
import { isArray } from 'lodash';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators';
import { SchedulerAllTracksRequest } from '../../../../../../scheduler-core/src/lib/states/scheduler-core.actions';
import { IntroOrExtro } from '../create-program/create-program.component';

@Component({
  selector: 'rk-intro-extro',
  templateUrl: './intro-extro.component.html',
  styleUrls: ['./intro-extro.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IntroExtroComponent implements OnInit {
  @Select(BacsState.bacsGroup)
  bacsGroups$: Observable<BacGroup[]>;

  @ViewChild('header')
  header: ElementRef<HTMLDivElement>;

  @Input()
  type: IntroOrExtro;

  @Output()
  applyTrack = new EventEmitter<SchedulerTrack>();

  allBox = '__ALL__';

  searchSubject = new BehaviorSubject<string>('');

  selectedBox = new BehaviorSubject<string>(this.allBox);
  tracks$: Observable<SchedulerTrack[]>;
  tracksUnfiltered$: Observable<SchedulerTrack[]>;

  constructor(
    private readonly store: Store,
    private readonly searchService: SearchService,
  ) {}

  ngOnInit() {
    this.tracksUnfiltered$ = this.selectedBox.asObservable().pipe(
      switchMap(box => {
        if (box !== this.allBox) {
          return this.store
            .select(SchedulerCoreState.trackBacDbNameUnfiltered)
            .pipe(map(fn => fn(box)));
        } else {
          return this.store.select(SchedulerCoreState.allTracks);
        }
      }),
    );

    this.tracks$ = this.searchService
      .createTracksSearch(this.tracksUnfiltered$, this.searchSubject.asObservable(), true)
      .pipe(
        filter(val => isArray(val)),
        distinctUntilChanged(),
      );

    setTimeout(() => {
      this.getTracks();
    }, 100);
  }

  applyTrackClick(track: SchedulerTrack) {
    this.applyTrack.emit(track);
    this.searchSubject.next('');
  }

  selectBox(boxName: string) {
    this.selectedBox.next(boxName);
  }

  onChangeSearch(str: string) {
    this.searchSubject.next(str);
  }

  @Dispatch()
  getTracks = () =>
    new SchedulerAllTracksRequest(this.store.selectSnapshot(RadioState.currentRadioId));
}
